import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ReportsRoutingModule } from './reports-routing.module';
import { ReportParentComponent } from './report-parent/report-parent.component';
import { ReportsLandingComponent } from './reports-landing/reports-landing.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedComponentsModule } from 'src/app/shared-components/shared-components.module';
import { ReportDetailedComponent } from './report-detailed/report-detailed.component';
import { ReportEsignComponent } from './report-esign/report-esign.component';
import { ReportEstampComponent } from './report-estamp/report-estamp.component';

@NgModule({
  declarations: [
    ReportParentComponent,
    ReportsLandingComponent,
    ReportDetailedComponent,
    ReportEsignComponent,
    ReportEstampComponent
  ],
  imports: [
    CommonModule,
    ReportsRoutingModule,
    FormsModule,
    SharedComponentsModule,
    ReactiveFormsModule
  ]
})
export class ReportsModule { }
